import type { IOrderItem } from "@/data/model/Order";

import { Component } from "@/shared/elements/Component";

import { OrderItem } from "./OrderItem";

export class OrderItemsList extends Component {
    public readonly orderItems: IOrderItem[];
    public readonly displayPrice: boolean;
    public readonly isCompact: boolean;

    constructor(orderItems: IOrderItem[], displayPrice: boolean = false, isCompact: boolean = false) {
        super();
        this.orderItems = orderItems;
        this.displayPrice = displayPrice;
        this.isCompact = isCompact;

        this.$element = this.drawElement();
    }

    protected drawElement() {
        const orderItems = this.orderItems;

        // draw order item fields
        const $element = $('<div class="order-items" />');

        if (this.isCompact) $element.addClass("compact");

        for (const orderItem of orderItems) {
            OrderItem.render($element, orderItem, this.displayPrice);
        }

        return $element;
    }

    public static render(
        $appendToTarget: JQuery,
        orderItems: IOrderItem[],
        displayPrice: boolean = false,
        isCompact: boolean = false
    ): OrderItemsList {
        const component = new OrderItemsList(orderItems, displayPrice, isCompact);
        component.renderTo($appendToTarget);

        return component;
    }
}
